/**
 * The five elements of martial arts (ธาตุของวิชา). An art of the same element as the active
 * neigong hits harder; elements also tell players what an art is like at a glance.
 */
export type Element = 'yin' | 'soft' | 'taiji' | 'yang' | 'hard';

export const ELEMENTS: readonly Element[] = ['yin', 'soft', 'taiji', 'yang', 'hard'];

export const ELEMENT_INFO: Readonly<Record<Element, { name: string; glyph: string; color: string }>> = {
  yin: { name: 'หยิน', glyph: '陰', color: '#b07aff' },
  soft: { name: 'อ่อน', glyph: '柔', color: '#5cc8e8' },
  taiji: { name: 'ไทเก๊ก', glyph: '太', color: '#e6e6ee' },
  yang: { name: 'หยาง', glyph: '陽', color: '#f0c040' },
  hard: { name: 'แข็ง', glyph: '剛', color: '#c89060' },
};

/** Damage multiplier when the art's element matches the active neigong's. */
export const ELEMENT_MATCH_BONUS = 1.15;

/** External arts hit with body and blade (vs defence); internal arts with inner energy (vs internal defence). */
export type DamageType = 'external' | 'internal';
export const DAMAGE_TYPE_LABELS: Readonly<Record<DamageType, string>> = {
  external: 'ภายนอก',
  internal: 'ภายใน',
};
